import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {
	Alert,
	Form,
	Label,
	Row,
	Input,
	FormGroup,
	ButtonGroup,
	Button,
	Card,
	CardBody,
	CardHeader,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter
} from 'reactstrap';
import classnames from 'classnames';

import {
	getDetailSubcategories,
	saveSubcategories,
	deleteSubcategories,
	newSubcategories
} from '../../actions/subcategoriesAction';
import { getOptionList as getCategoryOptionList } from '../../actions/categoriesAction';
import { ValidationMessage } from '../../components/Form/ValidationMessage';
import { Radio, RadioText, FormGroupRadio } from '../../components/Form/Radios';
import { textValue } from '../../utils/form';

class SubcategoriesForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			_edit: this.props.edit,
			_hasId: !!this.props.match.params.id,
			_form: {
				binding: false,
				id: this.props.match.params.id,
				category_id: '',
				name: '',
				active: true,
				created_at: '',
				updated_at: ''
			},
			_formSubmit: false,
			_modalDelete: false
		};
	}

	componentDidMount() {
		this.props.bindCategoryOptions();
		if (this.state._hasId) {
			this.props.find(this.state._form.id);
		} else {
			this.props.new();
		}
	}

	isSuccessStatus(statusCode) {
		return statusCode === 200 || statusCode === 201;
	}

	componentDidUpdate(prevProps) {
		const { detail, isFetch, isSubmit, error } = this.props.masterSubcategories;
		const {
			isFetch: prevIsFetch,
			isSubmit: prevIsSubmit,
		} = prevProps.masterSubcategories;

		if (this.state._hasId) {
			if (!this.isSuccessStatus(detail.status_code) || error !== null) {
				return;
			}

			if (prevIsFetch && !isFetch && !this.state._form.binding) {
				this.setState({
					_form: { ...this.state._form, ...detail, binding: true }
				});
				return;
			}

			if (prevIsSubmit && !isSubmit && this.state._formSubmit) {
				this.setState({
					_form: { ...this.state._form, ...detail, binding: true },
					_formSubmit: false
				});
			}
			return;
		}

		if (
			this.isSuccessStatus(detail.status_code)
			&& error === null
			&& this.state._formSubmit
			&& prevIsSubmit
			&& !isSubmit
		) {
			this.setState({
				_form: {
					category_id: '',
					name: '',
					active: true,
					created_at: '',
					updated_at: ''
				},
				_formSubmit: false
			});
		}
	}

	handleChange(e) {
		const newState = { ...this.state._form };
		newState[e.target.name] = e.target.value;
		this.setState({ _form: newState });
	}

	handleCheckedChange(e) {
		const newState = { ...this.state._form };
		newState[e.target.name] = e.target.checked;
		this.setState({ _form: newState });
	}

	onSubmit(e) {
		e.preventDefault();
		this.setState({ _formSubmit: true }, () => {
			const { id, category_id, name, active } = this.state._form;
			this.props.save({
				id,
				category_id,
				name,
				active
			});
		});
	}

	renderLoading() {
		return (
			<div className="row">
				<div className="col-sm-12">
					<Alert color="info" className="text-center">Getting all data...</Alert>
				</div>
			</div>
		);
	}

	renderInfo() {
		const infoMessage = [];
		if (this.props.masterSubcategories.isSubmit) {
			infoMessage.push(
				<Alert color="info" key="info"><strong>Heads up!</strong> Submitting...</Alert>
			);
		}
		if (this.props.masterSubcategories.success) {
			infoMessage.push(
				<Alert color="success" key="success"><strong>Well done!</strong> {this.props.masterSubcategories.success}</Alert>
			);
		}
		if (this.props.masterSubcategories.error !== null) {
			const { status_code, message } = this.props.masterSubcategories.error;
			switch (status_code) {
				case 422:
					infoMessage.push(
						<Alert color="danger" key="error"><strong>Oh Snap!</strong> Please fullfill your form. </Alert>
					);
					break;
				case 404:
					infoMessage.push(
						<Alert color="danger" key="error"><strong>Oh Snap!</strong> Resource not found. </Alert>
					);
					break;
				case 400:
					infoMessage.push(
						<Alert color="danger" key="error">
							<strong>Oh Snap!</strong> {message || 'Bad request.'}
						</Alert>
					);
					break;
				default:
					infoMessage.push(
						<Alert color="danger" key="error">
							<strong>Oh Snap!</strong> {message || 'We\'ve got something errors'}
						</Alert>
					);
					break;
			}
		}
		return (
			<div className="row">
				<div className="col-sm-12">
					{infoMessage}
				</div>
			</div>
		);
	}

	validateError(name) {
		if (this.hasError(name)) {
			const errorList = this.props.masterSubcategories.error.errors;
			return <ValidationMessage message={errorList[name][0]} />;
		}
		return '';
	}

	hasError(name) {
		if (this.props.masterSubcategories.error) {
			if (this.props.masterSubcategories.error.errors) {
				const errorList = this.props.masterSubcategories.error.errors;
				const errList = Object.keys(errorList).filter(key => key === name);
				if (errList.length) {
					return true;
				}
			}
		}
		return false;
	}

	toggle() {
		this.setState({ _modalDelete: !this.state._modalDelete });
	}

	onDelete() {
		this.props.delete(this.state._form.id);
		this.toggle();
	}

	render() {
		if (this.props.masterSubcategories.detail.delete === true) {
			return <Redirect to="/subcategories" />;
		}
		return (
			<Row>
				<Modal isOpen={this.state._modalDelete} toggle={this.toggle.bind(this)} className="modal-dialog modal-sm">
					<ModalHeader toggle={this.toggle.bind(this)}>Confirmation</ModalHeader>
					<ModalBody>
						Are you sure to delete this subcategory?
					</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={this.onDelete.bind(this)}>Yes</Button>{' '}
						<Button color="secondary" onClick={this.toggle.bind(this)}>Cancel</Button>
					</ModalFooter>
				</Modal>
				<div className="col-md-6 offset-md-3">
					<Card>
						<CardHeader>
							<i className="fa fa-align-justify"></i> {this.props.title}
						</CardHeader>
						<CardBody>
							{this.renderInfo()}
							{
								this.props.masterSubcategories.isFetch ?
									this.renderLoading()
									:
									<Form onSubmit={this.onSubmit.bind(this)}>
										<FormGroup className={this.hasError('category_id') ? ' has-danger has-feedback' : ''}>
											<Label for="formSubcategoryCategory">Category</Label>
											<Input
												type="select"
												id="formSubcategoryCategory"
												name="category_id"
												value={this.state._form.category_id}
												onChange={this.handleChange.bind(this)}
											>
												<option value="">Select a category*</option>
												{
													this.props.categoryOptions.map(item => (
														<option key={item.value} value={item.value}>{item.label}</option>
													))
												}
											</Input>
											{this.validateError('category_id')}
										</FormGroup>
										<FormGroup className={this.hasError('name') ? ' has-danger has-feedback' : ''}>
											<Label for="formSubcategoryName">Subcategory Name</Label>
											<Input
												type="text"
												id="formSubcategoryName"
												name="name"
												placeholder="Enter a name*"
												maxLength={100}
												value={this.state._form.name}
												onChange={this.handleChange.bind(this)}
											/>
											{this.validateError('name')}
										</FormGroup>
										<FormGroupRadio
											className={classnames({ 'has-danger has-feedback': this.hasError('active') })}
										>
											<Radio
												type="checkbox"
												name="active"
												value={true}
												checked={textValue('active', this.state._form)}
												dataOnText="Yes"
												dataOffText="No"
												onChange={this.handleCheckedChange.bind(this)}
											/>
											<RadioText text="Set to Active" />
											{this.validateError('active')}
										</FormGroupRadio>
										{
											this.state._hasId ? (
												<React.Fragment>
													<FormGroup>
														<Label>Created At</Label>
														<Input
															type="text"
															readOnly
															value={this.state._form.created_at}
														/>
													</FormGroup>
													<FormGroup>
														<Label>Updated At</Label>
														<Input
															type="text"
															readOnly
															value={this.state._form.updated_at}
														/>
													</FormGroup>
												</React.Fragment>
											) : null
										}
										<FormGroup>
											<ButtonGroup>
												<Button
													color="primary"
													disabled={this.props.masterSubcategories.isSubmit}
												>
													{this.props.masterSubcategories.isSubmit ? 'Submitting...' : 'Submit'}
												</Button>
												{
													this.state._hasId ?
														<Button
															color="danger"
															disabled={this.props.masterSubcategories.isSubmit}
															onClick={this.toggle.bind(this)}
														>
															Delete
														</Button>
														:
														null
												}
											</ButtonGroup>
										</FormGroup>
									</Form>
							}
						</CardBody>
					</Card>
				</div>
			</Row>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		masterSubcategories: state.masterSubcategories,
		categoryOptions: state.masterCategories.options
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		find: (id) => dispatch(getDetailSubcategories(id)),
		delete: (id) => dispatch(deleteSubcategories(id)),
		save: (payload) => dispatch(saveSubcategories(payload)),
		new: () => dispatch(newSubcategories()),
		bindCategoryOptions: () => dispatch(getCategoryOptionList())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SubcategoriesForm);
